import React from 'react';

export default function H2HTab({ match }) {
  const h2h = match.h2h || [];
  const home = match.teams.home;
  const away = match.teams.away;

  // Compute summary
  const summary = h2h.reduce((acc, m) => {
    if (m.result === 'H') acc.home++;
    else if (m.result === 'A') acc.away++;
    else acc.draw++;
    return acc;
  }, { home: 0, draw: 0, away: 0 });

  if (h2h.length === 0) {
    return <div className="tab-empty"><p>No previous meetings.</p></div>;
  }

  return (
    <div className="h2h-view">
      <div className="h2h-summary">
        <div className="h2h-side">
          <img src={home.logo} alt={home.name} />
          <div className="h2h-count">{summary.home}</div>
          <div className="h2h-label">Wins</div>
        </div>
        <div className="h2h-divider">
          <div className="h2h-count draws">{summary.draw}</div>
          <div className="h2h-label">Draws</div>
        </div>
        <div className="h2h-side">
          <img src={away.logo} alt={away.name} />
          <div className="h2h-count">{summary.away}</div>
          <div className="h2h-label">Wins</div>
        </div>
      </div>

      <div className="h2h-list">
        <div className="h2h-list-title">Last 5 meetings</div>
        {h2h.map((m, i) => (
          <div key={i} className="h2h-row">
            <div className="h2h-date">{m.date}</div>
            <div className="h2h-comp">{m.competition}</div>
            <div className="h2h-result">
              <span className="h2h-team-name">{m.home}</span>
              <span className="h2h-score">{m.homeScore} - {m.awayScore}</span>
              <span className="h2h-team-name">{m.away}</span>
            </div>
            <div className={`h2h-badge ${m.result === 'H' ? 'win' : m.result === 'A' ? 'loss' : 'draw'}`}>
              {m.result}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
